<template>
  <div v-if="is_load" class="mb-2   text-wrap">
    <div class="editor_block_render"  v-if="current_blocks && current_blocks.length>0"  v-for="(block,index) in current_blocks" :key="index">
      <EditorjsColumns :align_style="custom_align_style" v-if="isshort==false && block.type=='columns' && block.data && block.data.cols && block.data.cols.length>0 " :block="block"/>


      <div class="card mt-4" v-if="block.type=='maps'">
        <div class="col-12" :key="'block_map'+key_for_blocks[block.id]" v-for="(addr,addr_key) in block.data.addrs" v-if="block.data.addrs && block.data.addrs.length>1" >
          <p :class="{text_zacherknut:(routes_confirm_data[block.id] && routes_confirm_data[block.id][0])}" v-if="addr_key==0">Начальный пункт:{{ addr.title }} </p>
          <p :class="{text_zacherknut:(routes_confirm_data[block.id] && routes_confirm_data[block.id][addr_key])}" v-if="block.data.addrs[addr_key+1] && addr_key>0">Остановка:{{ addr.title }} </p>
          <p v-if="!block.data.addrs[addr_key+1] && addr_key>0">Место назначения:{{ addr.title }}</p>
          <button @click="setFinishAddr(block.id,index,addr_key)"  v-if="addr_key==0 && enable_gps==true && routes_confirm_data[block.id] && !routes_confirm_data[block.id][0]" class="btn">доехал ✅</button>
          <button @click="setFinishAddr(block.id,index,addr_key)"  v-if="block.data.addrs[addr_key+1] && addr_key>0 && enable_gps==true && routes_confirm_data[block.id] && routes_confirm_data[block.id][addr_key-1] && !routes_confirm_data[block.id][addr_key]" class="btn">доехал ✅</button>
        </div>
        <div class="col-12" v-if="block.data.addrs.length>0">
          <p v-if="enable_gps==false" ><button @click="toogleGpsNavigation(block.id)" class="btn">Включить<br> навигацию</button></p>
          <p v-if="enable_gps==true" ><button @click="toogleGpsNavigation(block.id)" class="btn">Выключить<br> навигацию</button></p>
        </div>





        <l-map   style="height: 300px !important;"
                 :minZoom='1'
                 :maxZoom='20'
                 :zoom="zoom_map"
                 :center="getMapCenter(index)"
                 :options="{zoomSnap: 0.5}"


        >
          <l-tile-layer
              :url="url_map"
              :attribution="attribution"
          />
<!--          <l-routing-machine v-if="enable_gps==false" :waypoints="routes_data[block.id]"/>-->
          <l-routing-machine v-if="enable_gps==true" :key="'block'+key_for_blocks[block.id]" :waypoints="getWaypointbyBlockId(block.id)"/>
          <l-marker v-if="enable_gps==true && gps_data.lat && gps_data.lon"   :lat-lng="[parseFloat(gps_data.lat), parseFloat(gps_data.lon)]">
            <l-icon

                icon-url="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48IS0tIFVwbG9hZGVkIHRvOiBTVkcgUmVwbywgd3d3LnN2Z3JlcG8uY29tLCBHZW5lcmF0b3I6IFNWRyBSZXBvIE1peGVyIFRvb2xzIC0tPg0KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMiAyMS4yNUMxMS44NTMgMjEuMjUxNCAxMS43MDkzIDIxLjIwNTkgMTEuNTkgMjEuMTJDMTEuMjkgMjAuOTMgNC4yNSAxNi4yIDQuMjUgMTAuNDVDNC4yNSA4LjM5NDUyIDUuMDY2NTIgNi40MjMyOCA2LjUxOTkyIDQuOTY5ODdDNy45NzMzMyAzLjUxNjQ3IDkuOTQ0NTcgMi42OTk5NSAxMiAyLjY5OTk1QzE0LjA1NTQgMi42OTk5NSAxNi4wMjY3IDMuNTE2NDcgMTcuNDgwMSA0Ljk2OTg3QzE4LjkzMzUgNi40MjMyOCAxOS43NSA4LjM5NDUyIDE5Ljc1IDEwLjQ1QzE5Ljc1IDE2LjIgMTIuNzUgMjAuOTMgMTIuNDEgMjEuMTJDMTIuMjkwNyAyMS4yMDU5IDEyLjE0NyAyMS4yNTE0IDEyIDIxLjI1Wk0xMiA0LjI0OTk1QzEwLjM0OTQgNC4yNDQ2MyA4Ljc2NDIgNC44OTQ1NCA3LjU5MjM4IDYuMDU2OTlDNi40MjA1NiA3LjIxOTQzIDUuNzU3OTQgOC43OTkzOSA1Ljc1IDEwLjQ1QzUuNzUgMTQuNjYgMTAuNTQgMTguNTEgMTIgMTkuNThDMTMuNDYgMTguNTEgMTguMjUgMTQuNjYgMTguMjUgMTAuNDVDMTguMjQyMSA4Ljc5OTM5IDE3LjU3OTQgNy4yMTk0MyAxNi40MDc2IDYuMDU2OTlDMTUuMjM1OCA0Ljg5NDU0IDEzLjY1MDYgNC4yNDQ2MyAxMiA0LjI0OTk1WiIgZmlsbD0iIzAwMDAwMCIvPg0KPHBhdGggZD0iTTEyIDEyLjc1QzExLjQ1NjEgMTIuNzUgMTAuOTI0NCAxMi41ODg3IDEwLjQ3MjIgMTIuMjg2NUMxMC4wMTk5IDExLjk4NDQgOS42Njc0NyAxMS41NTQ5IDkuNDU5MzMgMTEuMDUyNEM5LjI1MTE5IDEwLjU0OTkgOS4xOTY3MyA5Ljk5Njk1IDkuMzAyODQgOS40NjM1QzkuNDA4OTUgOC45MzAwNiA5LjY3MDg2IDguNDQwMDUgMTAuMDU1NSA4LjA1NTQ2QzEwLjQ0MDEgNy42NzA4NiAxMC45MzAxIDcuNDA4OTUgMTEuNDYzNSA3LjMwMjg0QzExLjk5NyA3LjE5NjczIDEyLjU0OTkgNy4yNTExOSAxMy4wNTI0IDcuNDU5MzNDMTMuNTU0OSA3LjY2NzQ3IDEzLjk4NDQgOC4wMTk5NSAxNC4yODY1IDguNDcyMThDMTQuNTg4NyA4LjkyNDQyIDE0Ljc1IDkuNDU2MSAxNC43NSAxMEMxNC43NSAxMC43MjkzIDE0LjQ2MDMgMTEuNDI4OCAxMy45NDQ1IDExLjk0NDVDMTMuNDI4OCAxMi40NjAzIDEyLjcyOTMgMTIuNzUgMTIgMTIuNzVaTTEyIDguNzVDMTEuNzUyOCA4Ljc1IDExLjUxMTEgOC44MjMzMSAxMS4zMDU1IDguOTYwNjZDMTEuMSA5LjA5ODAyIDEwLjkzOTggOS4yOTMyNCAxMC44NDUyIDkuNTIxNjVDMTAuNzUwNSA5Ljc1MDA1IDEwLjcyNTggMTAuMDAxNCAxMC43NzQgMTAuMjQzOUMxMC44MjIzIDEwLjQ4NjMgMTAuOTQxMyAxMC43MDkxIDExLjExNjEgMTAuODgzOUMxMS4yOTA5IDExLjA1ODcgMTEuNTEzNyAxMS4xNzc4IDExLjc1NjEgMTEuMjI2QzExLjk5ODYgMTEuMjc0MiAxMi4yNDk5IDExLjI0OTUgMTIuNDc4NCAxMS4xNTQ5QzEyLjcwNjggMTEuMDYwMiAxMi45MDIgMTAuOSAxMy4wMzkzIDEwLjY5NDVDMTMuMTc2NyAxMC40ODg5IDEzLjI1IDEwLjI0NzIgMTMuMjUgMTBDMTMuMjUgOS42Njg0OCAxMy4xMTgzIDkuMzUwNTQgMTIuODgzOSA5LjExNjEyQzEyLjY0OTUgOC44ODE3IDEyLjMzMTUgOC43NSAxMiA4Ljc1WiIgZmlsbD0iIzAwMDAwMCIvPg0KPC9zdmc+"

               />
          </l-marker>
          <l-marker v-for="(addr,addr_key) in block.data.addrs" :key="addr_key" :lat-lng="[parseFloat(addr.lat), parseFloat(addr.lon)]">
            <l-icon

                icon-url="data:image/png;base64,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"
            />
          </l-marker>

        </l-map>




      </div>

      <p class="lead mt-4"   :class="{'text-left':(block.data.alignment && block.data.alignment=='left' && iscenter==false),'text-right':(block.data.alignment && block.data.alignment=='right' && iscenter==false),'text-center':((block.data.alignment && block.data.alignment=='center') || iscenter==true),'text-justify':((block.data.alignment && block.data.alignment=='justify') && iscenter==false)}"  v-if="block.type=='paragraph'" v-on:click.stop.prevent="openLinkParagraph" v-html="block.data.text"></p>
<div class="" :class="{'text-left':((block.data.alignment && block.data.alignment=='left') && iscenter==false ),'text-right':((block.data.alignment && block.data.alignment=='right') && iscenter==false),'text-center':((block.data.alignment && block.data.alignment=='center') || iscenter==true),'text-justify':((block.data.alignment && block.data.alignment=='justify') && iscenter==false)}" v-if="block.type=='header'">
  <h1 class="mt-1 mt-4" v-if="block.type=='header' && block.data.level==1" v-html="block.data.text"></h1>
  <h2 class="mt-1 mt-4" v-if="block.type=='header' && block.data.level==2" v-html="block.data.text"></h2>
  <h3 class="mt-1 mt-4" v-if="block.type=='header' && block.data.level==3" v-html="block.data.text"></h3>
  <h4 class="mt-1 mt-4" v-if="block.type=='header' && block.data.level==4" v-html="block.data.text"></h4>
  <h5 class="mt-1 mt-4" v-if="block.type=='header' && block.data.level==5" v-html="block.data.text"></h5>
  <h6 class="mt-1 mt-4" v-if="block.type=='header' && block.data.level==6" v-html="block.data.text"></h6>
</div>


      <div class=" " :class="{'d-flex justify-content-center':iscenter}" v-if="block.type=='list' && block.data.style=='ordered' && block.data.items.length>0">

      <ol class="mt-1 mt-4" v-if="block.type=='list' && block.data.style=='ordered' && block.data.items.length>0">
        <li v-for="(item_ordered,index) in block.data.items" :key="index" v-html="item_ordered"></li>
      </ol>
      </div>
      <div class=" " :class="{'d-flex justify-content-center':iscenter}" v-if="block.type=='list' && block.data.style=='unordered' && block.data.items.length>0">
      <ul class="mt-1 mt-4" v-if="block.type=='list' && block.data.style=='unordered' && block.data.items.length>0">
        <li v-for="(item_unordered,index) in block.data.items" :key="index" v-html="item_unordered"></li>
      </ul>
      </div>

      <div class="" :class="{'d-flex justify-content-center':iscenter}" v-if="block.type=='telegramembed'">
        <div class="col-sm-12 col-12 col-md-6 mt-4 telegram_embed ml-0 pl-0"  v-if="block.type=='telegramembed'">

          <p v-if="(window_js.Telegram && window_js.Telegram.WebApp && window_js.Telegram.WebApp.initData)"><a :href="block.data.link" target="_blank">Ссылка в Telegram</a></p>

          <component v-if="!(window_js.Telegram && window_js.Telegram.WebApp && window_js.Telegram.WebApp.initData)"    is="script" data-dark="1" :key="block.id" src="https://telegram.org/js/telegram-widget.js?22" async :data-telegram-post="block.data.link.replace('https://t.me/','')" data-width="80%"></component>

        </div>
      </div>

      <div class="col-12 col-sm-12 m-1 " v-if="block.type=='vote' && votes && votes[block.data.vote_id] && votes_answer[block.data.vote_id] && Object.keys(votes_answer[block.data.vote_id]).length>0">
       <div class="well p-0">
         <div class="col-12 p-3">
           <div class="card">
             <div class="card-header">
               {{ votes[block.data.vote_id]["name"] }}
             </div>

           </div>

           <div class="card" v-if="votes[block.data.vote_id]['current_page']=='results'" v-for="(question,index) in votes[block.data.vote_id]['questions']" :key="'results_questions_'+block.data.vote_id+'_'+question.id" >
             <div class="card-header">
               {{ question["name"] }}
             </div>
             <div class="card-body">
               <div class="col-10" v-for="(variant,index) in question['variants']" :key="'questions_'+block.data.vote_id+'_questionid'+question.id+'_'+variant.id" >

                 <p v-if="variant.current==true"><mark>{{ variant["name"] }}   <small class="text-muted ml-4" v-if="question.total==0">0%</small>  <small class="text-muted ml-4" v-if="question.total>0">{{ Math.floor((variant.total * 100 )/ question.total) }}%</small> <span class="pull-right">{{ variant.total }}</span></mark></p>
                 <p v-if="variant.current==false">{{ variant["name"] }}   <small class="text-muted ml-4" v-if="question.total==0">0%</small>  <small class="text-muted ml-4" v-if="question.total>0">{{ Math.floor((variant.total * 100 )/ question.total) }}%</small> <span class="pull-right">{{ variant.total }}</span></p>
               </div>


               <p class="ml-4"><u>Всего голосов - {{ question.total}}</u></p>

             </div>
           </div>
         <div class="card" v-if="votes[block.data.vote_id]['current_page']=='form'" v-for="(question,index) in votes[block.data.vote_id]['questions']" :key="'form_questions_'+block.data.vote_id+'_'+question.id" >
           <div class="card-header">
             {{ question["name"] }}
           </div>
           <div class="card-body">
             <div v-for="(variant,index) in question['variants']" :key="'questions_'+block.data.vote_id+'_questionid'+question.id+'_'+variant.id" >
               <p v-if="votes[block.data.vote_id]['have_vote']==false && votes[block.data.vote_id]['can_vote']==true && question['multiple']==0">
                 <input v-model="votes_answer[block.data.vote_id]['question_'+question.id]" :value="variant.id" type="radio"/> {{ variant["name"] }}
               </p>
               <p v-if="votes[block.data.vote_id]['have_vote']==false && votes[block.data.vote_id]['can_vote']==true && question['multiple']==1">
                 <input v-model="votes_answer[block.data.vote_id]['question_'+question.id]" :value="variant.id" type="checkbox"/> {{ variant["name"] }}
               </p>
               <p v-if="votes[block.data.vote_id]['have_vote']==true || (votes[block.data.vote_id]['have_vote']==false && votes[block.data.vote_id]['can_vote']==false) ">{{ variant["name"] }}  (проголосовало {{ variant.total }})  <b v-if="question.total==0">0%</b>  <b v-if="question.total>0">{{ (variant.total * 100 )/ question.total }}%</b></p>
             </div>


           <p v-if="votes[block.data.vote_id]['have_vote']==true">Всего голосов - {{ question.total}}</p>

           </div>
         </div>


         <div class="row col-12">
           <div class="col-12 col-md-6 col-lg-6">
             <div class="row" :key="'vote_btn_'+block.data.vote_id" v-if="votes[block.data.vote_id]['current_page']=='form' && votes[block.data.vote_id]['have_vote']==false && votes[block.data.vote_id]['can_vote']==true">
               <div class="col-12">
                 <p v-if="votes_error[block.data.vote_id] && votes_error[block.data.vote_id]['iserror']==true">{{ votes_error[block.data.vote_id]["message"]}}</p>

                 <p><button class="btn" @click="startVote(index)"><i class="fa fa-user-secret"></i> <i class="fa fa-thumbs-up"></i></button></p>
               </div>
             </div>
             <div :key="'vote_btn_'+block.data.vote_id" v-if="votes[block.data.vote_id]['current_page']=='results' && votes[block.data.vote_id]['have_vote']==false && votes[block.data.vote_id]['can_vote']==true">
               <div class="col-12 col-md-6 col-lg-6">
                 <p v-if="votes_error[block.data.vote_id] && votes_error[block.data.vote_id]['iserror']==true">{{ votes_error[block.data.vote_id]["message"]}}</p>
                 <p>голосование полностью анонимное <i class="fa fa-user-secret"></i></p>
                 <p><button class="btn" @click="changeVote(index)">Назад</button></p>
               </div>
             </div>
             <div :key="'change_vote_btn_'+block.data.vote_id" v-if="votes[block.data.vote_id]['have_vote']==true && votes[block.data.vote_id]['can_vote']==true">
               <p><button class="btn" @click="changeVote(index)"><i class="fa fa-repeat"></i> Еще раз</button></p>
             </div>
           </div>


       </div>
           <div class="row" v-if="votes[block.data.vote_id]['current_page']=='form'">
             <div class="col-12 col-md-6 col-lg-6 " >
               <p  class="ml-3 ml-sm-0 ml-md-0 ml-lg-0 ml-xl-0"><button class="btn" @click="changeVoteToResult(index)">Результаты</button></p>
             </div>
           </div>
         </div>
        </div>





        </div>
      <div class="col-sm-12 mt-4" :class="{'no-gutters':(block.data.config=='carousel')}" v-if="block.type=='carousel'">

        <div class="col-12" v-if="block.data.config=='masonry'">
          <div class="masonry-wrapper">
          <div class="card-columns masonry_rows_cards" :style="'column-count:'+block.data.countItemEachRow+';-moz-column-count:'+block.data.countItemEachRow+';-webkit-column-count:'+block.data.countItemEachRow+';'"   >

            <div class="card" @click="(event)=>{

         if(slides[block.id].img_urls['image_'+index]){
             openLink(slides[block.id].img_urls['image_'+index])
          }else {

            var caption='Изображение';
          if(item_image.caption){
            caption=item_image.caption;
          }
         openModal(item_image.url,caption);
          }

        }" v-for="(item_image,index) in block.data.items" :key="index" >

              <v-lazy-image   :src="resize_image(item_image.url,320)" sizes="(max-width: 320px) 320px,
            (max-width: 640px) 640px,
            (max-width: 960px) 960px,
            1000px"  :srcset="getSrcset(item_image.url)"  class="card-img-top"  style="max-width: 100%; max-height: 500px;"/>

              <div class="card-header-masonry card-header  text-center" v-if="item_image.caption" >
              <p v-html="item_image.caption"></p>
              </div>




            </div>




          </div>
          </div>

        </div>
        <div class="col-12 no-gutters" v-if="block.data.config=='carousel'">



          <div class="slides_gallery">
           <transition  mode="out-in" name="fade-new">
             <div class="slider_main_div"  @touchstart="(event)=>startTouchSlide(block,event)"
                 @touchmove="(event)=>endTouchSlide(block,event)"    v-for="(item_image,index) in block.data.items" :key="index" v-if="slides[block.id].slide==index && slides[block.id].sliding==true" >
             <div class="control_slide" >
<!--               <div-->
<!--                   class="slide-fragment"-->
<!--                   :style="'background-image: url(' + item_image.url + '); z-index: 2;'">-->
<!--               </div>-->

<!--               &lt;!&ndash; фрагменты для следующего слайда &ndash;&gt;-->
<!--               <div v-if="block.data.items.length>index+1 && block.data.items[index+1].url"-->
<!--                   class="slide-fragment"-->
<!--                   :style="'background-image: url(' + block.data.items[index+1].url + '); z-index: 1;'">-->
<!--               </div>-->
<!--               <div v-if="!(block.data.items.length>index+1 && block.data.items[index+1].url) && block.data.items[0].url"-->
<!--                   class="slide-fragment"-->
<!--                   :style="'background-image: url(' + block.data.items[0].url + '); z-index: 1;'">-->
<!--               </div>-->
               <div class="img_container"  @click="()=>{

        if(slides[block.id].img_urls['image_'+index]){
             openLink(slides[block.id].img_urls['image_'+index])
          }else {


          var caption='Изображение';
          if(item_image.caption){
            caption=item_image.caption;
          }
         openModal(item_image.url,caption);
              }
        }">
                 <div class="caption_slide d-none d-sm-none d-md-block" v-if="item_image.caption">
                   <p v-html="item_image.caption"></p>
                 </div>
                 <v-lazy-image    :src="resize_image(item_image.url,320)"  sizes="(max-width: 320px) 320px,
            (max-width: 640px) 640px,
            (max-width: 960px) 960px,
            1000px"  :srcset="getSrcset(item_image.url)" class="img-fluid  img-center"/></div>


               <div class="slide_prev_btn d-none d-sm-none d-md-block">

                 <button @click="prevSlide(block)"
                   class="btn btn-second"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
               </div>
               <div class="slide_next_btn d-none d-sm-none d-md-block">

                 <button @click="nextSlide(block)" class="btn btn-second"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
               </div>
<!--               <div class="inner_div_block  slider_caption_main d-none d-sm-none d-md-block">-->
<!--                 <p class="text-center" v-if="item_image.caption" v-on:click.stop.prevent="openLinkParagraph" v-html="item_image.caption"></p>-->
<!--               </div>-->
             </div>


             </div>
           </transition>


          </div>






      </div>
        <card-gallery @clickImage="(image)=>{

          var caption='Изображение';
          if(image.caption){
            caption=image.caption;
          }
         openModal(image.url,caption);
        }" v-if="block.data.config=='standard'" :images="block.data.items"/>

      </div>

      <div class="col-12 mt-4  d-flex justify-content-center " :class="{'w-100':(block.data.stretched && block.data.stretched==true),'image__picture--with-background':(block.data.withBackground && block.data.withBackground==true)}"    @click="()=>{

          var caption='Изображение';
          if(block.data.caption){
            caption=block.data.caption;
          }
         openModal(block.data.file.url,caption);
        }" v-if="block.type=='image' && !block.data.file.url.includes('video')">
        <div class="img_div " :class="{'w-100':(block.data.stretched && block.data.stretched==true)}"  >
          <v-lazy-image   :src="resize_image(block.data.file.url,320)" sizes="(max-width: 320px) 320px,
            (max-width: 640px) 640px,
            (max-width: 960px) 960px,
            1000px"  :srcset="getSrcset(block.data.file.url)"   class="img-fluid mx-auto img-thumbnail" :class="{'image__picture--stretched':(block.data.stretched && block.data.stretched==true)}"  style="max-width: 100%; max-height: 500px;"/>
          <p v-if="block.data.caption" class="ml-4 mt-4 text-center" v-on:click.stop.prevent="openLinkParagraph" v-html="block.data.caption"></p>
        </div>




      </div>

      <div class="col-12 mt-4  d-flex justify-content-center " :class="{'w-100':(block.data.stretched && block.data.stretched==true),'image__picture--with-background':(block.data.withBackground && block.data.withBackground==true)}"    v-if="block.type=='image' && (block.data.file.url.includes('video')) ">
        <div class="img_div video_div " :class="{'w-100':(block.data.stretched && block.data.stretched==true)}"  >
          <div class="ml-3  embed-responsive embed-responsive-4by3">
            <video controls class="embed-responsive-item"  >
              <source id='mp4' :src="block.data.file.url"   />

            </video>
          </div>

          <p v-if="block.data.caption" class="ml-4 mt-4 text-center" v-on:click.stop.prevent="openLinkParagraph" v-html="block.data.caption"></p>

        </div>




      </div>





      <div class="row mt-4 " v-if="block.type=='attaches' && (block.data.file.url.includes('video')) ">

        <video controls class="embed-responsive"  >
          <source id='mp4' :src="block.data.file.url"   />

        </video>
      </div>
        <div class="row mt-4 " v-if="block.type=='attaches' && !(block.data.file.url.includes('video'))">
          <div class="col-12 col-sm-12 col-md-6 ">
            <div class="media">
              <i class="fa fa-file-o fa-4x mr-3"></i>
              <div class="media-body" v-on:click.stop.prevent="openLink(block.data.file.url)">
                <h5 class="mt-0 text-perenos">{{ block.data.file.name }}</h5>
                <p v-if="block.data.file.extension">Тип файла: {{ block.data.file.extension}}</p>
                <a :href="block.data.file.url" class="btn ">Скачать</a>
              </div>
            </div>
          </div>
        </div>

      <div class="" :class="{'d-flex justify-content-center':iscenter}" v-if="block.type=='figma'">
      <div class="embed-responsive mt-4 embed-responsive-16by9" v-if="block.type=='figma'">
        <iframe class="embed-responsive-item"  v-if="block.type=='figma'" :src="'https://www.figma.com/embed?embed_host=share&url='+block.data.link"></iframe>
      </div>
      </div>
      <div class="" :class="{'d-flex justify-content-center':iscenter}" v-if="block.type=='rutubeembed'">
      <div class="embed-responsive mt-4 embed-responsive-16by9" v-if="block.type=='rutubeembed'">
        <iframe class="embed-responsive-item"  v-if="block.type=='rutubeembed'" :src="'https://rutube.ru/play/embed/'+block.data.video_code"></iframe>
      </div>
      </div>
      <div class="" :class="{'d-flex justify-content-center':iscenter}" v-if="block.type=='vkclipsembed'">
      <div class="mt-4 " style="height:100%;" v-if="block.type=='vkclipsembed'">

        <iframe class="story_iframe"     v-if="block.type=='vkclipsembed'" :src="block.data.iframe_url.replace('amp;','')"></iframe>

      </div>
      </div>
      <div class="" :class="{'d-flex justify-content-center':iscenter}" v-if="block.type=='vkvideoembed'">
      <div class="embed-responsive mt-4 embed-responsive-16by9" v-if="block.type=='vkvideoembed'">

        <iframe class="embed-responsive-item"  v-if="block.type=='vkvideoembed'" :src="block.data.iframe_url.replace('amp;','')"></iframe>

      </div>
      </div>
      <div class="" :class="{'d-flex justify-content-center':iscenter}" v-if="block.type=='embed'">
      <div class="embed-responsive mt-4 embed-responsive-16by9" v-if="block.type=='embed'">
        <iframe class="embed-responsive-item"  v-if="block.type=='embed'" :src="block.data.embed"></iframe>
      </div>
      </div>
      <div class="" :class="{'d-flex justify-content-center':iscenter}" v-if="block.type=='quote'">
      <blockquote v-if="block.type=='quote' && block.data.alignment=='left'" class="blockquote mt-4 text-left">
        <p class="mb-0">{{ block.data.text }}</p>
        <footer v-if="block.data.caption.length>0" class="blockquote-footer">{{ block.data.caption }}

        </footer>
      </blockquote>
      <blockquote v-if="block.type=='quote' && block.data.alignment=='center'" class="mt-4 blockquote text-center">
        <p class="mb-0">{{ block.data.text }}</p>
        <footer v-if="block.data.caption.length>0" class="blockquote-footer">{{ block.data.caption }}</footer>
      </blockquote>
      </div>

      <div  v-if="block.type=='AnyButton'" class="col-12 mt-3 mb-3 mx-auto d-flex align-items-center justify-content-center">
        <a class="btn" v-on:click.stop.prevent="openLink(block.data.link)" :href="block.data.link">{{ block.data.text }}</a>
      </div>

      <div class="renderce-block mb-3" v-if="block.type=='linkTool'">
        <div class="renderce-block__content" >
        <div class="cdx-block">
        <div class="link-tool">
          <div class="link-tool__content link-tool__content--rendered" target="_blank" rel="nofollow noindex noreferrer" v-on:click.stop.prevent="openLink(block.data.link)">
            <div class="link-tool__image" v-if="block.data.meta && block.data.meta.image && block.data.meta.image.url" :style="'background-image: url(\''+block.data.meta.image.url+'\');'"></div>

            <a class="link-tool__title" :href="block.data.link" v-if="block.data.meta && block.data.meta.title">{{ block.data.meta.title}}</a>
            <p class="link-tool__description" v-if="block.data.meta && block.data.meta.description">{{ block.data.meta.description}} </p>
            <span class="link-tool__anchor" v-if="block.data.meta && block.data.meta.site_name">{{ block.data.meta.site_name}}</span>
            <span class="link-tool__anchor" v-if="!(block.data.meta && block.data.meta.site_name)">&nbsp;</span>
          </div>
        </div>
        </div>
        </div>
      </div>


      <div class="container link_block_content mt-4 " v-if="block.type=='linkTool2'">
        <div class="row" v-on:click.stop.prevent="openLink(block.data.link)">
          <div class="col-sm-2"  v-if="block.data.meta && block.data.meta.image && block.data.meta.image.url">
            <v-lazy-image  :src="block.data.meta.image.url" class="img-fluid" />
          </div>
          <div class="col-sm-10">
            <h5 class="mt-2" v-if="block.data.meta && block.data.meta.title">{{ block.data.meta.title}}</h5>
            <p  class="mt-2" v-if="block.data.meta && block.data.meta.site_name">{{ block.data.meta.site_name}}</p>
            <p class="mt-2"   v-if="block.data.meta && block.data.meta.description">{{ block.data.meta.description}} </p>
            <a v-if="block.data.link"    :href="block.data.link" style="max-width: 300px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" class="btn btn_redirect mt-2 mb-2">{{ block.data.link }}</a>
          </div>
        </div>
      </div>

      <div class="col-12" ref="readmore" v-if="block.type=='delimiter'">
        <p class="lead mt-4 text-center"  >* * *</p>
      </div>

      <div v-if="block.type=='raw'" v-html="block.data.html">
      </div>
      <table class="table mt-4 table-page-content" v-if="block.type=='table'">
        <tr v-for="(tr,index) in block.data.content" :key="index">
          <td v-for="(td,index) in tr" :key="index">{{ td }}</td>
        </tr>
      </table>
      <div class=" " :class="{'d-flex justify-content-center':iscenter}" v-if="block.type=='warning'">
      <div class="alert mt-4 alert-warning" v-if="block.type=='warning'" role="alert">
        <h4 class="alert-heading " :class="{'text-center':iscenter}" v-if="block.data.title">{{ block.data.title }}</h4>
        <p v-if="block.data.message" :class="{'text-center':iscenter}" v-html="block.data.message"></p>
      </div>
      </div>
      <div class=" " :class="{'d-flex justify-content-center':iscenter}" v-if="block.type=='checklist'">
      <ul class="mt-4 checklist_editorjs" v-if="block.type=='checklist'  && block.data.items.length>0">
        <li  v-for="(item_check,index) in block.data.items" :key="index">
          <p v-if="item_check.checked==true" v-html="check_icon+item_check.text"></p>
          <p v-if="item_check.checked==false" v-html="uncheck_icon+item_check.text"></p>

        </li>
      </ul>
      </div>
    </div>

       <modal  class="modal  "  v-if="is_modal==true"  :show.sync="is_modal"

              modal-main-classes="modal-fullscreen ">

<div class="d-flex justify-content-center">
  <v-lazy-image  :src="modal_image"  class="img-fluid " />
</div>

         <div class="col-12 d-flex justify-content-center">



           <p class="mt-2" v-on:click.stop.prevent="openLinkParagraph" v-html="modal_text"></p>


         </div>
         <div class="col-12 modal_image_div_close d-flex justify-content-center">
           <p class="mt-2"> <button class="btn" type="button" @click="is_modal = false"
           >
             <span>×</span>
           </button></p>
         </div>
         <template slot="footer">


         </template>



      </modal>



  </div>
</template>
<script>
import Vue from "vue";

import VLazyImage from "v-lazy-image/v2";
import L from 'leaflet';
import { LMap, LTileLayer, LMarker,LIcon } from 'vue2-leaflet';
import LRoutingMachine from "../components/LRoutingMachine";
import Modal from '@/components/Modal.vue';
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
import Api from "./Api";
import CardGallery from "@/components/Custom/CardGallery";

import EditorjsColumns from "./EditorjsColumns";




export default {
  name: "Editorjsrender",
  components: {

    VLazyImage,
    'modal':Modal,
    CardGallery,
    LMap,
    LIcon,
    LTileLayer,
    LMarker,
    LRoutingMachine,
    BCarousel,
    BCarouselSlide,
    'EditorjsColumns': EditorjsColumns,
  },
  props: {
    blocks_json: {
      type: Array,
      required: true
    },
    align_style:{
      type:String,
      required:false,

    },
    isshort:{
      type:Boolean,
      required:false,
      default:false,
    },
    scroll:{
      type:Boolean,
      required:false,
      default:false,
    }


  },
  mounted() {
    var app=this;
    app.window_js = window;

    if(app.align_style && app.align_style=="center"){
      app.iscenter=true;
    }
    if(app.align_style){
      app.custom_align_style=app.align_style;
    }
    var items=[];
    var routes_data=app.routes_data;
    var routes_confirm_data=app.routes_confirm_data;
    var key_for_blocks=app.key_for_blocks;
    if(app.blocks_json && app.blocks_json.length>0){
      var current_blocks=app.blocks_json;
      var blocks_for_show=[];
      var i_block=0;
      while(current_blocks[i_block]){
        var cur_block=current_blocks[i_block];
        if(app.iscenter==false && cur_block.data && cur_block.data.alignment && cur_block.data.alignment=='center'){
          app.iscenter=true;
          app.custom_align_style='center';
        }

        if(cur_block.type=="delimiter" && app.isshort==true){
          break;
        }
        blocks_for_show.push(cur_block);
        i_block++;
      }




      app.current_blocks=blocks_for_show;

      app.blocks_json.forEach(async (block,block_index) => {
        key_for_blocks[block.id]=block.id;
        if(block.type && block.type=='image'){
          var new_block=block;
          new_block.index=block_index
          items.push(new_block);
        }else if(block.type=="vote"){

           Api.loadVote(block.data.vote_id,function(data){


             var vote_answer_default={};
             data.vote.questions.forEach(function(question){
               var id_question=question.id;
               if(!vote_answer_default.hasOwnProperty('question_'+question.id)){
                 if(question.multiple==1){
                   vote_answer_default['question_'+question.id]=[];
                 }else {
                   vote_answer_default['question_'+question.id]="";
                 }

               }
               // question.variants.forEach(function(variant){
               //   vote_answer_default['question_'+question.id]["variant_"+variant.id]=null;
               //
               // });
             });
            //  app.votes_answer[block.data.vote_id]=vote_answer_default;
             app.$set(app.votes_answer, block.data.vote_id, vote_answer_default);
             app.$set(app.votes_error, block.data.vote_id, {"iserror":false,"message":""});
             if(data.vote['have_vote']==true || (data.vote['have_vote']==false && data.vote['can_vote']==false) ){
               data.vote.current_page="results";
             }else {
               data.vote.current_page="form";
             }
             app.$set(app.votes, block.data.vote_id, data.vote);

           },function(err){

           });
        }else if(block.type=="maps"){
          var current_routes=[];
          if(block.data && block.data.addrs && block.data.addrs.length>0){
            block.data.addrs.forEach(function(element,index){
              current_routes.push({ lat: parseFloat(element.lat), lng: parseFloat(element.lon) });
            });

          }
          routes_data[block.id]=current_routes;
          routes_confirm_data[block.id]=[];

        }else if(block.type=="carousel"){

          var img_urls={};
            block.data.items.forEach(function(elem,elem_index){
              var res_img=Api.findUrlInText(elem.caption);
              if(res_img && res_img[0]){
                img_urls["image_"+elem_index]=res_img[0];
              }
            })
          //console.log('current img_urls',img_urls);

          app.slides[block.id]={
            'img_urls':img_urls,
            slide: 0,
            sliding: true,
            // interval:setInterval(function(){
            //   app.nextSlide(block,true);
            // }, 3000)
            };
          app.startAutoSlide(block);


        }
      });

      app.routes_data=routes_data;
    //  console.log('keys for block',key_for_blocks);
      app.key_for_blocks=key_for_blocks;
      app.routes_confirm_data=routes_confirm_data;

      app.images=items;
      app.is_load=true;
      if(app.scroll==true){

      }
    }
    this.$nextTick(() => {
      //this.$refs.myMap.mapObject.ANY_LEAFLET_MAP_METHOD();
      if(this.isscrolling==false && this.scroll==true){
        this.scrollToElement();
      }
    });

  },
  methods:{
    getSrcset(url){
      var app=this;
      var result=app.resize_image(url,320)+' 320w,'+app.resize_image(url,640)+' 640w,'+app.resize_image(url,960)+' 960w,'+url+' 1000w';
      return result;
    },
    resize_image(path,width){
      return Api.resize_image(path,width);
    },
    startAutoSlide(block) {
      var app=this;
      app.autostart_slide[block.id]=setTimeout(() => {
        app.nextSlide(block, true,function(){
          app.startAutoSlide(block);
        });
       // рекурсивный вызов для автоматической смены слайдов
      }, 3000); // автоматическая смена каждые 3 секунд
    },
    stopAutoSlide(block) {
      var app=this;
      clearTimeout(app.autostart_slide[block.id]);
    },
    setFinishAddr(block_id,block_index,addr_key){
      var app=this;
      var block=app.current_blocks[block_index];
    //  console.log('current finish block',block);
      if(block.data.addrs[addr_key] && !app.routes_confirm_data[block.id][addr_key]){
        app.routes_confirm_data[block.id].push(1);
        var current_key_id=app.key_for_blocks[block.id];
        var modify_current_key_id=current_key_id+Math.floor(Math.random() * 10).toString();
      //  console.log('setfinishaddr',{"current":current_key_id,"modify":modify_current_key_id});
        app.key_for_blocks[block.id]=modify_current_key_id;

      }
    },
    getWaypointbyBlockId(block_id){
      var app=this;
      var current_waypoints_data=app.routes_data[block_id].filter(function(element,index){
        if(!app.routes_confirm_data[block_id][index]){
          return true;
        }else {
          return false;
        }
      });
     // console.log(current_waypoints_data);
      var result=[{ lat: parseFloat(app.gps_data.lat), lng: parseFloat(app.gps_data.lon) }].concat(current_waypoints_data);
     // console.log('return waypoints is ',result);
      return result;
    },
    getMapCenter(index){
      var block=this.current_blocks[index];

      if(this.enable_gps==false){
        return [parseFloat(block.data.addrs[0].lat), parseFloat(block.data.addrs[0].lon)];
      }else {

       // console.log('map center is ',[parseFloat(this.gps_data.lat),parseFloat(this.gps_data.lon)]);
        return [parseFloat(this.gps_data.lat),parseFloat(this.gps_data.lon)];
      }
    },
    toogleGpsNavigation(block_id){
      var app=this;
      if(app.enable_gps==false){


        const success = (position) => {
          const latitude  = position.coords.latitude;
          const longitude = position.coords.longitude;
          var obj={
            lat:latitude,
            lon:longitude
          }
          // { lat: parseFloat(element.lat), lng: parseFloat(element.lon) }
          // if(app.routes_data[block_id][0].lat==latitude && app.routes_data[block_id][0].lat==longitude){
          // var firstEl={ lat: latitude, lng: longitude };
          // var newRoutesData=[{ lat: gps_data.lat, lng: gps_data.lon }].concat(routes_data[block_id]);
          //
          //
          //
          // console.log('newRoutesData',{"routes_data":newRoutesData});
          //
          // app.routes_data[block_id]=newRoutesData;
          // }

          app.gps_data=obj;
          app.enable_gps=true;

         // console.log('gps data is',[{ lat: parseFloat(app.gps_data.lat), lng: parseFloat(app.gps_data.lon) }].concat(app.routes_data[block_id]));


          // Do something with the position
        };

        const error = (err) => {

         // console.log('err geolocation');
         // console.log(err);
        };

        // This will open permission popup
        navigator.geolocation.watchPosition(success, error);
      }else {
        app.enable_gps=false;
      }
    },
    changeVoteToResult(block_index){
      var app=this;
      var current_block=app.current_blocks[block_index];
      var vote_id=current_block.data.vote_id;
      var vote=app.votes[vote_id];
      vote.current_page="results";


      app.$set(app.votes, current_block.data.vote_id, vote);
    },
    changeVote(block_index){
      var app=this;
      var current_block=app.current_blocks[block_index];
      var vote_id=current_block.data.vote_id;
      var vote=app.votes[vote_id];
      var vote_result={"questions":{}};
      vote.have_vote=false;
      vote.current_page="form";
      app.$set(app.votes, current_block.data.vote_id, vote);
    },
    startVote(block_index){

      var app=this;
      var current_block=app.current_blocks[block_index];
      var vote_id=current_block.data.vote_id;
      var vote=app.votes[vote_id];
      var vote_result={"questions":{}};
      vote.questions.forEach(function(question){

        if(question.multiple==0) {
          var tmp_int = parseInt(app.votes_answer[current_block.data.vote_id]["question_" + question.id]);
          if (!Number.isInteger(tmp_int)) {
            var votes_error                                    = app.votes_error;
            votes_error[current_block.data.vote_id]["iserror"] = true;
            votes_error[current_block.data.vote_id]["message"] = "Вы не полностью заполнили форму";
            // app.votes_error=votes_error;
            app.$set(app.votes_error, current_block.data.vote_id, votes_error[current_block.data.vote_id])
          } else {

            vote_result["questions"]["question_" + question.id] = tmp_int;
          }
        }else{
          var tmp_arr=app.votes_answer[current_block.data.vote_id]["question_" + question.id];
          if(tmp_arr.length>0){
            vote_result["questions"]["question_" + question.id] = tmp_arr;

          }
        }
      })


      Api.sendVoteAnswer(vote_id,vote_result,function(data){
        data.vote.current_page="results";
        app.$set(app.votes, current_block.data.vote_id, data.vote);
      },function(err){
        app.$set(app.votes_error, current_block.data.vote_id, {"iserror":true,"message":err});
      })


    },
    scrollToElement() {

      const el = this.$refs.readmore;


      if (el) {


        // Use el.scrollIntoView() to instantly scroll to the element
        el[0].scrollIntoView({behavior: 'smooth'});
        this.isscrolling=true;
      }
    },
    openLinkParagraph(e){
      e.preventDefault();
      if(e.target.href){
        this.openLink(e.target.href,e);
      }



    },
    openLink(url,e){
      if(e){
        e.preventDefault();
      }
      var base_url=Vue.config.BASE_URL_FRONT;
      const parse_base_url=new URL(base_url);
      const parse_url = new URL(url);



      if(parse_url.hostname==parse_base_url.hostname){
         this.$router.push(parse_url.pathname);
      }else {
        //document.location.href=url;
        window.open(url, '_blank').focus();
      }

      return false;
    },
    openModal(url,caption){
      var app=this;
      app.modal_image=url;
      app.modal_text=caption;
      app.is_modal=true;

    },
    startTouchSlide(block,evt){
      var app=this;
      var current_config=app.slides;

      current_config[block.id].touch_data={
        xDown: evt.touches[0].clientX,
        yDown:evt.touches[0].clientY
      };


     // console.log('finish start touch',current_config);
      app.slides=Object.assign({}, app.slides, current_config);

    },
    endTouchSlide(block,evt){
      var app   = this;
      //console.log('end touch event',{event:evt,'block':block,'data':app.slides[block.id]});
      if(app.slides[block.id].touch_data.xDown && app.slides[block.id].touch_data.yDown && evt.touches[0]
      && evt.touches[0].clientX && evt.touches[0].clientY) {

        var xDown = app.slides[block.id].touch_data.xDown;
        var yDown = app.slides[block.id].touch_data.yDown;
        var xUp   = evt.touches[0].clientX;
        var yUp   = evt.touches[0].clientY;

        // console.log('touch action move', {
        //   xDown: xDown,
        //   yDown: yDown,
        //   xUp  : xUp,
        //   yUp  : yUp,
        // });

        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
          if (xDiff > 0) {
            /* left swipe */
            app.prevSlide(block);
          } else {
            /* right swipe */
            app.nextSlide(block);
          }
        }
      }
    },
    prevSlide(block){
      var app=this;

      var current_config=app.slides;
      current_config[block.id].sliding=false;


      var current_slide=current_config[block.id].slide;

      app.stopAutoSlide(block);


      // clearInterval(current_config[block.id].interval);
      // current_config[block.id].interval=setInterval(function(){
      //   app.nextSlide(block,true);
      // }, 5000);
      var prev_slide=current_slide-1;
      if(current_slide>0){
        current_config[block.id].slide=prev_slide;
        current_config[block.id].sliding=true;

        app.slides=Object.assign({}, app.slides, current_config);

      }else {
        var last_element=block.data.items.length-1;
        current_config[block.id].slide=last_element;
        current_config[block.id].sliding=true;

        app.slides=Object.assign({}, app.slides, current_config);
      }
      app.startAutoSlide(block);
      //app.slides[block.id].sliding=true;
    },
    nextSlide(block,auto=false,success){



      var app=this;
      if(auto==false){
        app.stopAutoSlide(block);
      }
      var current_config=app.slides;
      current_config[block.id].sliding=false;

     Object.assign(app.slides, block.id, current_config[block.id]);

      var current_slide=current_config[block.id].slide;
      var next_slide=current_slide+1;


      if(block.data.items[next_slide]){
        current_config[block.id].slide=next_slide;
        current_config[block.id].sliding=true;
       // console.log('next slide event is '+next_slide);
       // Object.assign(app.slides, block.id, current_config[block.id]);
        app.slides=Object.assign({}, app.slides, current_config);

      }else {
        current_config[block.id].slide=0;
        current_config[block.id].sliding=true;

        app.slides=Object.assign({}, app.slides, current_config);
      }
      if (typeof success === 'function') {
        success();
      }
      if(auto==false){
        app.startAutoSlide(block);
      }
     // app.slides[block.id].sliding=true;
    },
    onResize() {
      this.$refs.map.mapObject.invalidateSize();
    }
  },
  data: function () {
    return {
      "slides":{

      },
      'check_icon':"<i class=\"fa fa-check\" aria-hidden=\"true\" v-if=\"item_check.checked==true\"></i>&nbsp;",
      'uncheck_icon':"<i class=\"fa fa-circle-o\" aria-hidden=\"true\"></i>&nbsp;",
      "iscenter":false,
      "autostart_slide":{

      },
      'enable_gps':false,
      'gps_data':{

      },
      "votes":{},
      "votes_answer":{

      },
      "votes_error":{

      },
      'window_js':null,
      "isscrolling":false,
      'is_load':false,
      'is_modal':false,
      'modal_image':'',
      'modal_text':'',
      'current_blocks':null,
      'images':[],
      'routes_data':{},
      'routes_confirm_data':{},
      'key_for_blocks':{},
      showModal:{},
      showModalBlock:{},
      url_map: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom_map: 15,
      custom_align_style:'',
    }
  },
}

</script>